import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import Button from "../../../../components/button";
import { setLoading } from "../../../../reducer/auth/auth";
import {
  deauthorizeCalendly,
  deauthorizePersonalCalendar,
  getZoomAuthUrl,
  LinkPersonalCalendar,
} from "../../../../services/uidata";
import {
  unLinkUserCalendar,
  unLinkUserZoom,
  updateGoogleSync,
} from "../../../../reducer/userSlice";
import "./integration.css";
import "./redesign.css";
import ConfirmDeleteModal from "../../../../components/deleteConfirmModal";
import Topbar from "../../../../components/topbar/topbar";
import {
  fetchLinkedCalendar,
  fetchLinkedZoomAccount,
  getLinkedEmail,
  getLinkedPaymentToken,
  savePaymentMedtods,
  savePaymentToForward,
  syncGoogleCalendarFinishSetup,
  syncGoogleCalendarFinishSetupConfirmation,
  updateGoogleCalendar,
  updateGoogleSyncSettings,
  verifyPaymentOtp,
} from "../../../../services/medium";
import { toast } from "react-toastify";
import { copyToClipboard } from "../../../../utils/helpers";
import GoToAvailability from "./gotoAvailabilityPopup";
import GoogleButton from "../../../../components/googlebutton";
import PaypalPdf from "./docs/PayPalIntegration.pdf";
import StripePdf from "./docs/StripeIntegration.pdf";
import SquarePdf from "./docs/SquarePaymentGateway.pdf";
import Validation from "../../../register/client/validation";
import TickMark from "../../../../components/tickmark";
import ConfirmIfCalendarSelected from "./confirmIfCalendarSelected";
import FinishPopup from "./finishPopup";

const WEBHOOK_SETUP_GUIDE = {
  stripe: {
    dashboardUrl: "https://dashboard.stripe.com/",
    dashboardLabel: "Open Stripe dashboard",
    steps: [
      "Log into your Stripe dashboard.",
      "Go to Developers, then Webhooks.",
      "Click Add endpoint.",
      "Copy the VerySoul Webhook URL above, then paste it into the Endpoint URL field in Stripe.",
      "Select these events: checkout.session.completed, payment_intent.succeeded, payment_intent.payment_failed, checkout.session.expired.",
      "Save the endpoint, then open it and reveal the Signing secret.",
      "Copy the secret, paste it into the Stripe Webhook Signing Secret field above, then save here too.",
    ],
  },
  paypal: {
    dashboardUrl: "https://developer.paypal.com/dashboard/",
    dashboardLabel: "Open PayPal dashboard",
    steps: [
      "Log into the PayPal Developer Dashboard.",
      "Go to Apps and Credentials, then select your app.",
      "Scroll to Webhooks and click Add Webhook.",
      "Copy the VerySoul Webhook URL above, then paste it into the URL field in PayPal.",
      "Scroll through the events list to find the: Checkout section and check CHECKOUT.ORDER.APPROVED and CHECKOUT.ORDER.DECLINED, then find the Payment section and check PAYMENT.CAPTURE.COMPLETED and PAYMENT.CAPTURE.DENIED.",
      "Save, then copy the Webhook ID it generates.",
      "Paste it into the PayPal Webhook ID field above, then save here too.",
    ],
  },
  square: {
    dashboardUrl: "https://developer.squareup.com/apps",
    dashboardLabel: "Open Square dashboard",
    steps: [
      "Log into the Square Developer Dashboard.",
      "Open your application, then go to Webhooks.",
      "Click Add Endpoint.",
      "Copy the VerySoul Webhook URL above, then paste it into the Notification URL field in Square.",
      "Subscribe to the payment.updated event.",
      "Save, then copy the Signature Key shown for that endpoint.",
      "Paste it into the Square Webhook Signature Key field above, then save here too.",
    ],
  },
};

export default function IntegrateModule() {
  const auth = useSelector((state) => state.auth);
  const {
    provider,
    google_calendar,
    id,
    google_availability_sync,
    show_payment_gateways,
    is_pay_forward,
  } = useSelector((state) => state.user.user);
  const userLoginDetail = useSelector((state) => state.user);

  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const [status] = useState("zoom");
  const [tabOne, setTabOne] = useState(false);
  const [tabTwo, setTabTwo] = useState(false);
  const [tabThree, setTabThree] = useState(false);
  const [zoomconnectedemail, setZoomconnectedemail] = useState(false);
  const [zoomconnectedemailName, setZoomconnectedemailName] = useState(false);
  const [googleconnectedemail, setGoogleconnectedemail] = useState("");
  const [subcalendarname, setSubCalendarName] = useState("");
  const [calendarList, setCalendarList] = useState([]);
  const [str_pub_key, setstr_pub_key] = useState("");
  const [str_pri_key, setstr_pri_key] = useState("");
  const [paypal_pub_key, setpaypal_pub_key] = useState("");
  const [paypal_pri_key, setpaypal_pri_key] = useState("");
  const [squareup_access_token, setsquareup_access_token] = useState("");
  const [square_location_id, setsquare_location_id] = useState("");
  const [str_webhook_secret, setstr_webhook_secret] = useState("");
  const [paypal_webhook_id, setpaypal_webhook_id] = useState("");
  const [square_webhook_signature_key, setsquare_webhook_signature_key] =
    useState("");
  const [activePaymentTab, setActivePaymentTab] = useState("paypal");
  const [showWebhookHelp, setShowWebhookHelp] = useState(false);
  const [googleavailabilitysync, setGoogleAvailabilitySync] = useState(0);
  const [isDirty, setIsDirty] = useState(false);
  // Snapshot of the masked values returned by the server, used to detect
  // which fields the user actually edited so we never resubmit a masked
  // placeholder (e.g. "sk*************") back into the database.
  const [initialPaymentValues, setInitialPaymentValues] = useState({});

  const [typestripe1, SetTypeStripe1] = useState(true);
  const [typestripe2, SetTypeStripe2] = useState(true);
  const [typepaypal1, SetTypePaypal1] = useState(true);
  const [typepaypal2, SetTypePaypal2] = useState(true);
  const [typesquare1, SetTypeSquare1] = useState(true);
  const [typesquare2, SetTypeSquare2] = useState(true);
  const [typestripewebhook, SetTypeStripeWebhook] = useState(true);
  const [typepaypalwebhook, SetTypePaypalWebhook] = useState(true);
  const [typesquarewebhook, SetTypeSquareWebhook] = useState(true);
  // const onLogoutHandler = () => {
  //   logoutUser(dispatch, navigate);
  // };

  const [verifiedStatus, setVerifiedStatus] = useState(false);
  const [verified, setVerified] = useState(false);
  const [verificationCode, setVerificationCode] = useState("");
  const [verifiedTitle, setVerifiedTitle] = useState("Send Verification Code");
  const [verifiedError, setVerifiedError] = useState(false);
  const [verifiedMessage, setVerifiedMessage] = useState("");
  const [time, setTime] = useState(0);
  const [showResend, setshowResend] = useState(false);
  const [resend, setResend] = useState(0);
  const [Suggested_amount, setSuggested_amount] = useState("");
  const [pay_forward, setpay_forward] = useState(0);
  const [show_pay_forward, setshow_pay_forward] = useState(false);

  const [is_payment_integrated, setIs_payment_integrated] = useState(false);

  const [confirmCalendarSetup, setconfirmCalendarSetup] = useState(false);
  const [zoomconnecteErrorMessage, setzoomconnecteErrorMessage] = useState(
    false
  );

  const [paypalcheckbox, setpaypalcheckbox] = useState("");
  const [stripecheckbox, setstripecheckbox] = useState("");
  const [squarecheckbox, setsquarecheckbox] = useState("");
  const [paypalcheckboxstatus, setpaypalcheckboxstatus] = useState(false);
  const [stripecheckboxstatus, setstripecheckboxstatus] = useState(false);
  const [squarecheckboxstatus, setsquarecheckboxstatus] = useState(false);
  // Per-field "Required" flags for the key inputs, keyed by field name
  // (str_pub_key, str_pri_key, paypal_pub_key, paypal_pri_key,
  // squareup_access_token, square_location_id).
  const [fieldErrors, setFieldErrors] = useState({});

  function getPathFromUrl(url) {
    const newUrl = new URL(window.location.href);
    newUrl.searchParams.delete("status");
    newUrl.searchParams.delete("message");
    window.history.replaceState({}, document.title, newUrl.href);
  }

  useEffect(() => {
    // window.loadModal2("#ConfirmIfCalendarSelected", "show");
    setGoogleAvailabilitySync(google_availability_sync === 1 ? true : false);
  }, [google_availability_sync]);
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    console.log(
      google_calendar,
      "google_calendargoogle_calendargoogle_calendar"
    );
  }, [google_calendar]);

  useEffect(() => {
    setshow_pay_forward(is_pay_forward);
    let calendar_status = searchParams.get("status");
    let linked_status = searchParams.get("message");
    if (calendar_status && linked_status === "GoogleAccountLinked") {
      fetchLinkedCalendar()
        .then((data) => {
          console.log(data);
          if (data.data.status) {
            let info = data.data.data.calendar_list.map((item) => {
              if (item.id === "primary") {
                return {
                  ...item,
                  status: true,
                };
              } else {
                return {
                  ...item,
                  status: false,
                };
              }
            });
            setCalendarList(info);
            window.loadModal2("#integration-modal", "show");

            getLinkedEmail()
              .then((data) => {
                if (data.data.status) {
                  setGoogleconnectedemail(
                    data.data.data.google_connected_email
                  );
                  setSubCalendarName(data.data.data.google_calendar_id);
                  // checkConnections(data.data.data)
                }
              })
              .catch(() => {});
          }
        })
        .catch(() => {});
    } else {
      getLinkedEmail()
        .then((data) => {
          if (data.data.status) {
            setGoogleconnectedemail(data.data.data.google_connected_email);
            setSubCalendarName(data.data.data.google_calendar_id);
            // setVerifiedStatus(data.data.data.payment_integrated === "both" || data.data.data.payment_integrated === "stripe" || data.data.data.payment_integrated === "paypal" ? false : true);

            if (data.data.data.is_stripe) {
              setstr_pri_key("32");
              setstr_pub_key("32");
            }
            if (data.data.data.is_paypal) {
              setpaypal_pri_key("32");
              setpaypal_pub_key("323");
            }
            if (data.data.data.is_squareup) {
              setsquareup_access_token("32");
              setsquare_location_id("323");
            }
            // checkConnections(data.data.data)
          }
          console.log("integrated", data);
        })
        .catch(() => {});
    }
    if (calendar_status && linked_status === "ZoomAccountLinked") {
      // fetchLinkedZoomAccount()
      //   .then((data) => {
      //     if (data.data.status) {
      getLinkedEmail()
        .then((data) => {
          getPathFromUrl();
          // if (data.data.status) {
          setZoomconnectedemail(data.data.data.is_zoom_connected);
          setzoomconnecteErrorMessage(
            data.data.data.is_zoom_connected ? false : true
          );
          setZoomconnectedemailName(data.data.data.zoom_connected_email);
          // checkConnections(data.data.data)
          // }
        })
        .catch(() => {});
      //   }
      // })
      // .catch(() => { });
    } else {
      getLinkedEmail()
        .then((data) => {
          if (data.data.status) {
            setZoomconnectedemail(data.data.data.is_zoom_connected);
            setzoomconnecteErrorMessage(
              data.data.data.is_zoom_connected ? false : true
            );
            setZoomconnectedemailName(data.data.data.zoom_connected_email);
            // checkConnections(data.data.data)
          }
        })
        .catch(() => {});
    }
  }, []);

  const checkConnections = (data) => {
    if (googleconnectedemail !== null && zoomconnectedemail) {
      confirmIfCalendarSelectedHandler();
    }
  };
  const deauthorize = () => {
    dispatch(setLoading(true));
    deauthorizeCalendly()
      .then((data) => {
        dispatch(setLoading(false));
        if (data.data.status) {
          dispatch(unLinkUserZoom());
        }
      })
      .catch((err) => {
        dispatch(setLoading(false));
        console.log(err);
      });
  };
  const deauthorizeCalendar = () => {
    dispatch(setLoading(true));
    deauthorizePersonalCalendar()
      .then((data) => {
        dispatch(setLoading(false));
        console.log(data.data, "data.data");
        if (data.data.status) {
          setGoogleconnectedemail("");
          setSubCalendarName("");
          dispatch(unLinkUserCalendar());
        }
      })
      .catch((err) => {
        dispatch(setLoading(false));
        console.log(err);
      });
  };
  const onProceedHandler = () => {
    console.log(status, "zoom", provider);
    if ((status === "zoom" && provider === null) || provider === "") {
      getAuthUrl();
    }
    if (status === "zoom" && provider === "Zoom") {
      deauthorize();
    }
  };
  const onLinkCalendar = () => {
    if (google_calendar === null || google_calendar === "") {
      linkcalendar();
    } else {
      deauthorizeCalendar();
    }
  };
  const getAuthUrl = () => {
    dispatch(setLoading(true));
    getZoomAuthUrl("integration")
      .then((data) => {
        dispatch(setLoading(false));
        if (data.data.status) {
          window.open(data.data.data.redirect_url, "_self");
        }
      })
      .catch((err) => {
        dispatch(setLoading(false));
        console.log(err);
      });
  };
  const linkcalendar = () => {
    dispatch(setLoading(true));
    LinkPersonalCalendar(id, "integration")
      .then((data) => {
        dispatch(setLoading(false));
        if (data.data.status) {
          window.open(data.data.data.url, "_self");
        }
      })
      .catch((err) => {
        dispatch(setLoading(false));
        console.log(err);
      });
  };

  // const makeActive = (state) => {
  //   setStatus(state);
  // };
  const closeTabOne = () => {
    setTabOne(!tabOne);
    setTabTwo(false);
    setTabThree(false);
  };
  const closeTabTwo = () => {
    setTabOne(false);
    setTabThree(false);
    setTabTwo(!tabTwo);
  };
  const closeTabThree = () => {
    setTabOne(false);
    setTabTwo(false);
    setTabThree(!tabThree);
  };
  const selectCalendarHandler = (item) => {
    let info = calendarList.map((data) => {
      if (data.id == item.id) {
        return {
          ...data,
          status: true,
        };
      } else {
        return {
          ...data,
          status: false,
        };
      }
    });
    setCalendarList(info);
  };
  const saveSelectedCalendar = () => {
    let id = calendarList.filter((data) => data.status);
    let body = {
      google_calendar_id: id[0].id,
      google_calendar_name: id[0].summary,
    };
    console.log(id);
    updateGoogleCalendar(body)
      .then((data) => {
        if (data.data.status) {
          toast.success("Calendar Updated Succesfully", {
            position: "top-center",
          });
          getPathFromUrl();
          window.loadModal2("#integration-modal", "hide");
          setSubCalendarName(body.google_calendar_name);
          checkConnections();
        }
      })
      .catch(() => {});
  };
  const unlinkHnalder = (id) => {
    if (id === "ConfirmDeleteModalZoom") {
      onProceedHandler();
    } else {
      onLinkCalendar();
    }
  };
  const onOpenPayment = () => {
    window.loadModal2("#payment-modal", "show");
  };
  const paymentChangeHandler = (e) => {
    setIsDirty(true);
    let name = e.target.name;
    let value = e.target.value;
    if (fieldErrors[name]) {
      setFieldErrors((prev) => ({ ...prev, [name]: false }));
    }
    if (name === "str_pub_key") {
      setstr_pub_key(value);
    }
    if (name === "str_pri_key") {
      setstr_pri_key(value);
    }
    if (name === "paypal_pub_key") {
      setpaypal_pub_key(value);
    }
    if (name === "paypal_pri_key") {
      setpaypal_pri_key(value);
    }
    if (name === "squareup_access_token") {
      setsquareup_access_token(value);
    }
    if (name === "square_location_id") {
      setsquare_location_id(value);
    }
    if (name === "str_webhook_secret") {
      setstr_webhook_secret(value);
    }
    if (name === "paypal_webhook_id") {
      setpaypal_webhook_id(value);
    }
    if (name === "square_webhook_signature_key") {
      setsquare_webhook_signature_key(value);
    }
  };

  const isBlank = (value) => !value || !String(value).trim();

  const savePaymentMethods = (info) => {
    // Required-field validation runs first so the user sees exactly which
    // key(s) are missing before we even get to the Live-mode checkbox.
    if (info === "stripe") {
      const errors = {
        str_pub_key: isBlank(str_pub_key),
        str_pri_key: isBlank(str_pri_key),
      };
      setFieldErrors((prev) => ({ ...prev, ...errors }));
      if (errors.str_pub_key || errors.str_pri_key) {
        return;
      }
    } else if (info === "paypal") {
      const errors = {
        paypal_pub_key: isBlank(paypal_pub_key),
        paypal_pri_key: isBlank(paypal_pri_key),
      };
      setFieldErrors((prev) => ({ ...prev, ...errors }));
      if (errors.paypal_pub_key || errors.paypal_pri_key) {
        return;
      }
    } else if (info === "square") {
      const errors = {
        squareup_access_token: isBlank(squareup_access_token),
        square_location_id: isBlank(square_location_id),
      };
      setFieldErrors((prev) => ({ ...prev, ...errors }));
      if (errors.squareup_access_token || errors.square_location_id) {
        return;
      }
    }

    if (info === "stripe" && stripecheckbox == 1) {
      if (str_pub_key === str_pri_key) {
        toast.error("Wrong stripe Keys", { position: "top-center" });
        return;
      }
    } else if (info === "stripe" && stripecheckbox != 1) {
      setstripecheckboxstatus(true);
      return;
    }
    if (info === "paypal" && paypalcheckbox == 1) {
      if (paypal_pub_key === paypal_pri_key) {
        toast.error("Wrong paypal Keys", { position: "top-center" });
        return;
      }
    } else if (info === "paypal" && paypalcheckbox != 1) {
      setpaypalcheckboxstatus(true);
      return;
    }
    if (info === "square" && squarecheckbox == 1) {
      if (squareup_access_token === square_location_id) {
        toast.error("Wrong square Keys", { position: "top-center" });
        return;
      }
    } else if (info === "square" && squarecheckbox != 1) {
      setsquarecheckboxstatus(true);
      return;
    }
    // Only include a field in the request if the user actually changed it.
    // Fields left untouched still hold the masked value we displayed
    // (e.g. "sk*************"), and sending that back would overwrite the
    // real key in the database. Omitted keys are left alone by the backend.
    const changedFieldsOnly = (fields) => {
      const body = {};
      Object.entries(fields).forEach(([key, value]) => {
        if (value !== initialPaymentValues[key]) {
          body[key] = value;
        }
      });
      return body;
    };

    let body = {};
    if (info === "stripe") {
      body = changedFieldsOnly({
        str_pub_key,
        str_pri_key,
        str_webhook_secret,
      });
    } else if (info === "paypal") {
      body = changedFieldsOnly({
        paypal_pub_key,
        paypal_pri_key,
        paypal_webhook_id,
      });
    } else {
      body = changedFieldsOnly({
        squareup_access_token,
        square_location_id,
        square_webhook_signature_key,
      });
    }

    // Don't block the save on the frontend when nothing changed — just let
    // the request go through with whatever fields differ (possibly none).
    // The backend only touches keys it receives, so an empty/partial body
    // is a safe no-op there; no need to stop the user here.
    savePaymentMedtods(body)
      .then((data) => {
        if (data.data.status) {
          toast.success("Updated", { position: "top-center" });
          window.loadModal2("#payment-modal", "hide");
          // Keep our baseline in sync with what we just saved so the next
          // edit is compared against the real current state, not the stale
          // masked snapshot from page load.
          setInitialPaymentValues((prev) => ({ ...prev, ...body }));
          setIsDirty(false);
        } else {
          toast.error(data.data.message || "Could not save payment details", {
            position: "top-center",
          });
        }
      })
      .catch(() => {
        toast.error("Something went wrong. Please try again.", {
          position: "top-center",
        });
      });
  };

  const savePaymentToForwardHandler = () => {
    let body = {
      medium_id: id,
      pay_forward: pay_forward,
      Suggested_amount: Suggested_amount,
    };

    if (pay_forward == 1) {
      setshow_pay_forward(true);
    } else {
      setshow_pay_forward(false);
    }
    savePaymentToForward(body)
      .then((data) => {
        if (data.data.status) {
          toast.success("Updated", { position: "top-center" });
        }
      })
      .catch(() => {});
  };
  const changePayItforwardHandler = (e) => {
    let checked = e.target.checked;
    setpay_forward(checked ? 1 : 0);
    console.log(checked);
  };
  const changePayItforwardHandlerNew = (e) => {
    let checked = e.target.checked;
    let name = e.target.name;
      setpaypalcheckboxstatus(false)
      setsquarecheckboxstatus(false)
      setstripecheckboxstatus(false)
      // Checking/unchecking "Live mode" is itself a change the user wants
      // saved, so it must enable the Save button just like editing a key
      // field does — otherwise Save stays disabled and the API never fires.
      setIsDirty(true);
    if (name == "stripecheckbox") {
      setstripecheckbox(checked ? 1 : 0);
    } else if (name == "paypalcheckbox") {
      setpaypalcheckbox(checked ? 1 : 0);
    } else if (name == "squarecheckbox") {
      setsquarecheckbox(checked ? 1 : 0);
    }
  };

  const changeAvailabilityHandler = (e) => {
    e.stopPropagation();

    let body = {
      enable_google_sync: googleavailabilitysync ? 0 : 1,
    };
    updateGoogleSyncSettings(body)
      .then((data) => {
        if (data.data.status) {
          dispatch(updateGoogleSync(googleavailabilitysync ? 0 : 1));
          setGoogleAvailabilitySync(!googleavailabilitysync);
          toast.success("Google sync updated", { position: "top-center" });
        }
      })
      .catch(() => {
        toast.error("Something went wrong", { position: "top-center" });
      });
  };
  const changePassType = (type) => {
    if (type === 1) {
      SetTypeStripe1(!typestripe1);
    } else if (type === 2) {
      SetTypeStripe2(!typestripe2);
    } else if (type === 3) {
      SetTypePaypal1(!typepaypal1);
    } else if (type === 4) {
      SetTypePaypal2(!typepaypal2);
    } else if (type === 5) {
      SetTypeSquare1(!typesquare1);
    } else if (type === 6) {
      SetTypeSquare2(!typesquare2);
    } else if (type === 7) {
      SetTypeStripeWebhook(!typestripewebhook);
    } else if (type === 8) {
      SetTypePaypalWebhook(!typepaypalwebhook);
    } else if (type === 9) {
      SetTypeSquareWebhook(!typesquarewebhook);
    }
  };
  const clearPaymentField = () => {
    if (activePaymentTab === "paypal") {
      let body = {
        
        paypal_pub_key: "",
        paypal_pri_key: "",
        paypal_webhook_id: "",
      };

      savePaymentMedtods(body)
        .then((data) => {
          if (data.data.status) {
            toast.success("Cleared Payments", { position: "top-center" });
            window.loadModal2("#payment-modal", "hide");
            setInitialPaymentValues((prev) => ({ ...prev, ...body }));
          } else {
            toast.error(data.data.message || "Could not clear payment details", {
              position: "top-center",
            });
          }
        })
        .catch(() => {
          toast.error("Something went wrong. Please try again.", {
            position: "top-center",
          });
        });
      setpaypal_pri_key("");
      setpaypal_pub_key("");
      setpaypal_webhook_id("");
    } else if (activePaymentTab === "stripe") {
      let body = {
        str_pub_key: "",
        str_pri_key: "",
        str_webhook_secret: "",
      };

      savePaymentMedtods(body)
        .then((data) => {
          if (data.data.status) {
            toast.success("Cleared Payments", { position: "top-center" });
            window.loadModal2("#payment-modal", "hide");
            setInitialPaymentValues((prev) => ({ ...prev, ...body }));
          } else {
            toast.error(data.data.message || "Could not clear payment details", {
              position: "top-center",
            });
          }
        })
        .catch(() => {
          toast.error("Something went wrong. Please try again.", {
            position: "top-center",
          });
        });
      setstr_pri_key("");
      setstr_pub_key("");
      setstr_webhook_secret("");
    } else {
      let body = {
        squareup_access_token: "",
        square_location_id: "",
        square_webhook_signature_key: "",
      };

      savePaymentMedtods(body)
        .then((data) => {
          if (data.data.status) {
            toast.success("Cleared Payments", { position: "top-center" });
            window.loadModal2("#payment-modal", "hide");
            setInitialPaymentValues((prev) => ({ ...prev, ...body }));
          } else {
            toast.error(data.data.message || "Could not clear payment details", {
              position: "top-center",
            });
          }
        })
        .catch(() => {
          toast.error("Something went wrong. Please try again.", {
            position: "top-center",
          });
        });
      setsquareup_access_token("");
      setsquare_location_id("");
      setsquare_webhook_signature_key("");
    }
  };
  const getWebhookUrl = (gateway) => {
    return `${process.env.REACT_APP_API_URL}webhooks/${gateway}/${id}`;
  };
  const copyWebhookUrl = (gateway) => {
    copyToClipboard(getWebhookUrl(gateway));
    toast.success("Webhook URL copied", { position: "top-center" });
  };
  const reSendVerificationCodeHandler = () => {
    sendVerificationCodeHandler();
    setResend(2);
    setTimeout(() => {
      setResend(0);
    }, 4000);
  };
  const handleChangeVerification = (e) => {
    setVerificationCode(e.target.value);
  };

  const sendVerificationCodeHandler = () => {
    let body = {
      verification_code: verificationCode,
    };
    verifyPaymentOtp(body)
      .then((data) => {
        if (!data.data.status && data.data.message == "OTP sent Successfully") {
          setVerifiedTitle("Verify");
          setVerifiedMessage("Verification Code sent successfully");
          setVerifiedError(false);
        }
        if (!data.data.status && data.data.message == "Invalid OTP") {
          setVerifiedTitle("Verify");
          setVerifiedMessage("Invalid Verification Code");
          setVerifiedError(true);
        }
        if (data.data.status && data.data.message == "Code Verified") {
          getPaymentToken();
          setVerifiedTitle("Verified");
          setVerifiedMessage(data.data.message);
          // setshow_pay_forward(true);
          setVerifiedError(false);
          setVerified(true);
          setVerifiedStatus(true);
        }
      })
      .catch((data) => {
        setVerifiedMessage("Please Try Again");
        setVerifiedError(true);
      });
  };
  const getPaymentToken = () => {
    getLinkedPaymentToken()
      .then((data) => {
        if (data.data.status) {
          setpaypal_pri_key(data.data.data.paypal_pri_key);
          setpaypal_pub_key(data.data.data.paypal_pub_key);
          setstr_pri_key(data.data.data.str_pri_key);
          setstr_pub_key(data.data.data.str_pub_key);
          setsquareup_access_token(data.data.data.squareup_access_token);
          setsquare_location_id(data.data.data.square_location_id);
          setstr_webhook_secret(data.data.data.str_webhook_secret || "");
          setpaypal_webhook_id(data.data.data.paypal_webhook_id || "");
          setsquare_webhook_signature_key(
            data.data.data.square_webhook_signature_key || ""
          );
          setSuggested_amount(data.data.data.suggested_amount);
          setpay_forward(data.data.data.pay_forward);
          // Remember exactly what the server sent (these are masked, e.g.
          // "sk*************") so savePaymentMethods can tell which fields
          // the user actually typed into vs. left as the masked display value.
          setInitialPaymentValues({
            paypal_pri_key: data.data.data.paypal_pri_key,
            paypal_pub_key: data.data.data.paypal_pub_key,
            str_pri_key: data.data.data.str_pri_key,
            str_pub_key: data.data.data.str_pub_key,
            squareup_access_token: data.data.data.squareup_access_token,
            square_location_id: data.data.data.square_location_id,
            str_webhook_secret: data.data.data.str_webhook_secret || "",
            paypal_webhook_id: data.data.data.paypal_webhook_id || "",
            square_webhook_signature_key:
              data.data.data.square_webhook_signature_key || "",
          });
        }
      })
      .catch(() => {});
  };

  const confirmIfCalendarSelectedHandler = () => {
    console.log(confirmCalendarSetup);
    // if (confirmCalendarSetup) {
    let body = {
      user_id: id,
    };
    syncGoogleCalendarFinishSetup(body)
      .then((data) => {
        if (data.data.status) {
          window.loadModal2("#ConfirmIfCalendarSelected", "show");
          // window.loadModal2("#ConfirmIfCalendarSelected", "hide");
          // window.loadModal2("#FinishPopup", "show");
        }
      })
      .catch(() => {});
    // }
  };
  const finishPopupHandler = () => {
    if (confirmCalendarSetup) {
      let body = {
        user_id: id,
      };
      syncGoogleCalendarFinishSetupConfirmation(body)
        .then((data) => {
          if (data.data.status) {
            window.loadModal2("#ConfirmIfCalendarSelected", "hide");
            window.loadModal2("#gotoavailability", "show");
          }
        })
        .catch(() => {});
    }
  };
  const cancelFinishPopupHandler = () => {
    window.loadModal2("#FinishPopup", "hide");
    window.loadModal2("#gotoavailability", "show");
  };

  /* ---------- Redesign helpers (derived state only) ---------- */
  const zoomLinked = provider && provider === "Zoom";
  const calendarLinked = !(google_calendar === "" || google_calendar === null);
  const stripeSet = !(
    (str_pub_key === "" && str_pri_key === "") ||
    (str_pub_key === null && str_pri_key === null)
  );
  const paypalSet = !(
    (paypal_pub_key === "" && paypal_pri_key === "") ||
    (paypal_pub_key === null && paypal_pri_key === null)
  );
  const squareSet = !(
    (square_location_id === "" && squareup_access_token === "") ||
    (square_location_id === null && squareup_access_token === null)
  );
  const paymentSet =
    stripeSet || paypalSet || squareSet || Boolean(show_pay_forward);
  const connectedCount =
    (zoomconnectedemail ? 1 : 0) +
    (calendarLinked ? 1 : 0) +
    (paymentSet ? 1 : 0);

  const InfoIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="12" cy="12" r="9" />
      <path d="M12 8v5M12 16.5v.1" />
    </svg>
  );

  const EyeIcon = ({ open }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z" />
      <circle cx="12" cy="12" r="2.8" />
      {!open && <path d="M4 20 20 4" />}
    </svg>
  );

  const renderBadge = (ok, okText, warnText) => (
    <span className={`vsi-badge ${ok ? "vsi-badge-ok" : "vsi-badge-warn"}`}>
      <span className="vsi-dot"></span>
      {ok ? okText : warnText}
    </span>
  );

  return (
    <>
      {auth.role === "medium" && (provider === "" || provider === null) && (
        <Topbar />
      )}
      <div className="vsi-page min-height-100vh">
        <div className="vsi-container">
          {/* ---------- Heading ---------- */}
          <div className="vsi-heading">
            <h1>Integrations</h1>
            <p>Connect the tools you need to host and get paid for sessions</p>
          </div>

          {/* ---------- Summary strip ---------- */}
          <div className="vsi-summary">
            <div className="vsi-summary-left">
              <div
                className="vsi-ring"
                style={{
                  background: `conic-gradient(#2e9e6b 0 ${
                    connectedCount * 120
                  }deg, #ececec ${connectedCount * 120}deg 360deg)`,
                }}
              >
                <b>{connectedCount}/3</b>
              </div>
              <div>
                <h2>
                  {connectedCount === 3
                    ? "All integrations connected"
                    : `Almost there — ${connectedCount} of 3 integrations connected`}
                </h2>
                <p className="vsi-summary-sub">
                  {connectedCount === 3
                    ? "You're all set to host and get paid for sessions."
                    : !zoomconnectedemail
                    ? "Link your Zoom account to host sessions."
                    : !calendarLinked
                    ? "Link your personal calendar to sync availability."
                    : "Link a payment gateway to start accepting paid bookings."}
                </p>
              </div>
            </div>
            {connectedCount < 3 && !paymentSet && show_payment_gateways && (
              <button className="vsi-summary-cta" onClick={closeTabThree}>
                Finish payment setup <span className="vsi-btn-arrow">↓</span>
              </button>
            )}
          </div>

          {/* ---------- Cards ---------- */}
          <div className="vsi-grid">
            {/* ZOOM */}
            <div className={`vsi-card vsi-card-zoom ${tabOne ? "vsi-card-open" : ""}`}>
              <div className="vsi-card-h">
                <div className="vsi-icon-tile vsi-icon-zoom">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                  >
                    <rect x="2.5" y="6" width="13" height="12" rx="2.5" />
                    <path d="M15.5 10.5 21 7.5v9l-5.5-3z" />
                  </svg>
                </div>
                <div className="vsi-card-title">
                  <h3>Zoom</h3>
                  <div className="vsi-card-sub">Video sessions</div>
                </div>
                {renderBadge(zoomconnectedemail, "Connected", "Not connected")}
              </div>
              <div className="vsi-card-b">
                {zoomconnectedemail &&
                  typeof zoomconnectedemailName === "string" &&
                  zoomconnectedemailName !== "" && (
                    <div className="vsi-kv">
                      <span className="vsi-k">Account</span>
                      <span className="vsi-v">{zoomconnectedemailName}</span>
                    </div>
                  )}
                <div className="vsi-note">
                  <InfoIcon />
                  <span>
                    Be sure to download the Zoom app on every device you'll use
                    for VerySoul sessions, and log into your Zoom account when
                    hosting.
                  </span>
                </div>
                {!zoomLinked && (
                  <div className="vsi-note">
                    <InfoIcon />
                    <span>Zoom integration required to access the main menu.</span>
                  </div>
                )}
                {zoomconnecteErrorMessage && (
                  <div className="vsi-note vsi-note-danger">
                    <InfoIcon />
                    <span>
                      Your Zoom account has become disconnected from our system.
                      Use the button below, then select "Continue" to regain
                      access and be able to take future bookings.
                    </span>
                  </div>
                )}
              </div>
              <div className="vsi-card-f">
                {zoomLinked ? (
                  <button
                    className="vsi-btn vsi-btn-danger-ghost"
                    onClick={() =>
                      window.loadModal2("#ConfirmDeleteModalZoom", "show")
                    }
                  >
                    Unlink
                  </button>
                ) : (
                  <button
                    className="vsi-btn vsi-btn-primary"
                    onClick={closeTabOne}
                  >
                    {tabOne ? (
                      "Close instructions"
                    ) : (
                      <>
                        Link your Zoom <span className="vsi-btn-arrow">↓</span>
                      </>
                    )}
                  </button>
                )}
              </div>
            </div>

            {/* CALENDAR */}
            <div className={`vsi-card vsi-card-calendar ${tabTwo ? "vsi-card-open" : ""}`}>
              <div className="vsi-card-h">
                <div className="vsi-icon-tile vsi-icon-cal">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                  >
                    <rect x="3" y="5" width="18" height="16" rx="2.5" />
                    <path d="M8 3v4M16 3v4M3 10h18M8.5 14.5l2.3 2.3 4.7-4.3" />
                  </svg>
                </div>
                <div className="vsi-card-title">
                  <h3>Calendar</h3>
                  <div className="vsi-card-sub">Availability sync</div>
                </div>
                {renderBadge(calendarLinked, "Connected", "Not connected")}
              </div>
              <div className="vsi-card-b">
                {googleconnectedemail && (
                  <div className="vsi-kv">
                    <span className="vsi-k">Account</span>
                    <span className="vsi-v">{googleconnectedemail}</span>
                  </div>
                )}
                {googleconnectedemail !== null && subcalendarname && (
                  <div className="vsi-kv">
                    <span className="vsi-k">Subcalendar</span>
                    <span className="vsi-v">{subcalendarname}</span>
                  </div>
                )}
                {!calendarLinked && (
                  <div className="vsi-note">
                    <InfoIcon />
                    <span>
                      Link your personal calendar so your availability stays in
                      sync with your bookings.
                    </span>
                  </div>
                )}
              </div>
              <div className="vsi-card-f">
                {calendarLinked ? (
                  <button
                    className="vsi-btn vsi-btn-danger-ghost"
                    onClick={() =>
                      window.loadModal2("#ConfirmDeleteModalCalendar", "show")
                    }
                  >
                    Unlink
                  </button>
                ) : (
                  <button
                    className="vsi-btn vsi-btn-primary"
                    onClick={closeTabTwo}
                  >
                    {tabTwo ? (
                      "Close instructions"
                    ) : (
                      <>
                        Link your calendar{" "}
                        <span className="vsi-btn-arrow">↓</span>
                      </>
                    )}
                  </button>
                )}
              </div>
            </div>

            {/* PAYMENT */}
            <div
              className={`vsi-card vsi-card-payment ${
                !paymentSet && show_payment_gateways ? "vsi-card-attention" : ""
              } ${tabThree ? "vsi-card-open" : ""} ${
                show_payment_gateways ? "" : "vsi-card-disabled"
              }`}
            >
              <div className="vsi-card-h">
                <div className="vsi-icon-tile vsi-icon-pay">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                  >
                    <rect x="2.5" y="6" width="19" height="13" rx="2.5" />
                    <path d="M2.5 10.5h19M6 15h4" />
                  </svg>
                </div>
                <div className="vsi-card-title">
                  <h3>Payment</h3>
                  <div className="vsi-card-sub">Get paid for sessions</div>
                </div>
                {renderBadge(paymentSet, "Connected", "Action needed")}
              </div>
              <div className="vsi-card-b">
                <div className="vsi-gw-row">
                  <span className="vsi-gw-chip">
                    {paypalSet && <span className="vsi-tick">✓</span>} PayPal
                  </span>
                  <span className="vsi-gw-chip">
                    {stripeSet && <span className="vsi-tick">✓</span>} Stripe
                  </span>
                  <span className="vsi-gw-chip">
                    {squareSet && <span className="vsi-tick">✓</span>} Square
                  </span>
                  <span className="vsi-gw-chip">
                    {Boolean(show_pay_forward) && (
                      <span className="vsi-tick">✓</span>
                    )}{" "}
                    Pay It Forward
                  </span>
                </div>
                <div className="vsi-note">
                  <InfoIcon />
                  <span>
                    Please ensure that your selected payment provider aligns
                    with the session currency you've chosen in VerySoul.
                  </span>
                </div>
              </div>
              <div className="vsi-card-f">
                <button
                  className="vsi-btn vsi-btn-primary"
                  onClick={show_payment_gateways ? closeTabThree : () => {}}
                >
                  {tabThree ? (
                    "Close setup"
                  ) : paymentSet ? (
                    <>
                      Manage payment <span className="vsi-btn-arrow">↓</span>
                    </>
                  ) : (
                    <>
                      Set up payment <span className="vsi-btn-arrow">↓</span>
                    </>
                  )}
                </button>
              </div>
            </div>

          {/* ---------- Zoom instructions panel ---------- */}
          {tabOne && (
            <div className="vsi-panel vsi-panel-zoom">
              <div className="vsi-panel-h">
                <div>
                  <h3>Link your Zoom</h3>
                  <p>
                    You'll be redirected to Zoom to authorize VerySoul. Read
                    these instructions first.
                  </p>
                </div>
                <button
                  className="vsi-panel-close"
                  onClick={() => setTabOne(false)}
                >
                  ✕
                </button>
              </div>
              <div className="vsi-panel-body vsi-instructions">
                <div className="vsi-note" style={{ marginTop: 0 }}>
                  <InfoIcon />
                  <span>Be sure to click only this Zoom box when prompted.</span>
                </div>
                <div className="vsi-allow-row">
                  <img src="/integrationimages/check.png" alt="check" />
                  <span>
                    Allow this app to use my shared access permissions.{" "}
                    <a href="javascript:void(0);">Learn More</a>
                  </span>
                </div>
                <p>
                  By giving this app access, it will be able to take actions on
                  your behalf for other users, based on your permissions and
                  what the app can view or manage.
                </p>
                <p>
                  <strong>By clicking all,</strong>
                </p>
                <ul>
                  <li>
                    You agree to the{" "}
                    <a href="javascript:void(0);">
                      Zoom App marketplace terms of use
                    </a>
                  </li>
                  <li>
                    You give permission to this app to use the information it's
                    allowed to access in accordance with their{" "}
                    <a href="javascript:void(0);">Terms &amp; Privacy policy.</a>
                  </li>
                </ul>
                <p>You can remove this app at any time in My Apps.</p>
              </div>
              <div className="vsi-panel-foot">
                <button
                  className="vsi-btn vsi-btn-ghost cancel_first_link_zoom"
                  onClick={() => setTabOne(false)}
                >
                  Cancel
                </button>
                <button
                  className="vsi-btn vsi-btn-green"
                  onClick={onProceedHandler}
                >
                  Continue to Zoom
                </button>
              </div>
            </div>
          )}

          {/* ---------- Calendar instructions panel ---------- */}
          {tabTwo && (
            <div className="vsi-panel vsi-panel-calendar">
              <div className="vsi-panel-h">
                <div>
                  <h3>Link your personal calendar</h3>
                  <p>
                    You'll be redirected to Google to authorize calendar access.
                  </p>
                </div>
                <button
                  className="vsi-panel-close"
                  onClick={() => setTabTwo(false)}
                >
                  ✕
                </button>
              </div>
              <div className="vsi-panel-body vsi-instructions">
                <div className="vsi-note" style={{ marginTop: 0 }}>
                  <InfoIcon />
                  <span>Be sure to click both Google boxes when prompted.</span>
                </div>
                <img
                  className="vsi-instruct-img"
                  src={"/integrationimages/instruct.png"}
                  alt="Google permission instructions"
                />
              </div>
              <div className="vsi-panel-foot">
                <button
                  className="vsi-btn vsi-btn-ghost cancel_first_link_zoom"
                  onClick={() => setTabTwo(false)}
                >
                  Cancel
                </button>
                <GoogleButton onClick={onLinkCalendar} />
              </div>
            </div>
          )}

          {/* ---------- Payment setup panel ---------- */}
          {tabThree && (
            <div className="vsi-panel vsi-panel-payment">
              <div className="vsi-panel-h">
                <div>
                  <h3>Payment gateway setup</h3>
                  <p>
                    Pick a provider and enter its API credentials. You can
                    switch providers anytime.
                  </p>
                </div>
                <button
                  className="vsi-panel-close"
                  onClick={() => setTabThree(false)}
                >
                  ✕
                </button>
              </div>

              {!verifiedStatus && (
                <div className="vsi-panel-body">
                  <div className="vsi-otp">
                    <label className="vsi-otp-label">
                      Verify OTP to edit payment methods
                    </label>
                    <div className="vsi-otp-row">
                      {verifiedTitle !== "Send Verification Code" && (
                        <input
                          onChange={handleChangeVerification}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                            }
                          }}
                          value={verificationCode}
                          type="text"
                          id="codeverification"
                          name="codeverification"
                          placeholder="Code"
                        />
                      )}
                      <Button
                        status={0}
                        type="button"
                        className={`resend-btn w-unset height-45 min-width-130px ${
                          verifiedTitle === "Verify" ? "bg-green" : ""
                        }`}
                        onClick={
                          time === 0 ? sendVerificationCodeHandler : () => {}
                        }
                        title={verifiedTitle}
                      />
                      {(verifiedMessage !== "Verified" || showResend) && (
                        <>
                          {resend === 1 && (
                            <Button
                              status={0}
                              type="button"
                              className={`resend-btn w-unset height-45 min-width-130px ml-2`}
                              onClick={reSendVerificationCodeHandler}
                              title={"Resend"}
                            />
                          )}
                          {resend === 2 && <TickMark />}
                        </>
                      )}
                    </div>
                    {verifiedTitle == "Verified" && (
                      <div className="vsi-otp-hint">
                        <i>*</i>Email Succesfully Verfied
                      </div>
                    )}
                    {verifiedMessage && (
                      <div
                        className={`vsi-otp-msg ${
                          verifiedError ? "vsi-otp-err" : "vsi-otp-ok"
                        }`}
                      >
                        {verifiedMessage}
                      </div>
                    )}
                  </div>
                </div>
              )}

              {verifiedStatus && (
                <div className="vsi-pay-body">
                  {/* Gateway list */}
                  <div className="vsi-gw-list">
                    <button
                      onClick={() => {
                        setActivePaymentTab("paypal");
                        setIsDirty(false);
                        setShowWebhookHelp(false);
                      }}
                      className={`vsi-gw-opt ${
                        activePaymentTab === "paypal" ? "vsi-gw-sel" : ""
                      }`}
                    >
                      <span className="vsi-gw-logo vsi-gw-logo-pp">
                        <img src={"/integrationimages/paypal.png"} alt="PayPal" />
                      </span>
                      PayPal
                      {paypalSet && (
                        <span className="vsi-gw-configured">CONFIGURED</span>
                      )}
                    </button>
                    <button
                      onClick={() => {
                        setActivePaymentTab("stripe");
                        setIsDirty(false);
                        setShowWebhookHelp(false);
                      }}
                      className={`vsi-gw-opt ${
                        activePaymentTab === "stripe" ? "vsi-gw-sel" : ""
                      }`}
                    >
                      <span className="vsi-gw-logo vsi-gw-logo-st">
                        <img src={"/integrationimages/stripe.png"} alt="Stripe" />
                      </span>
                      Stripe
                      {stripeSet && (
                        <span className="vsi-gw-configured">CONFIGURED</span>
                      )}
                    </button>
                    <button
                      onClick={() => {
                        setActivePaymentTab("square");
                        setIsDirty(false);
                        setShowWebhookHelp(false);
                      }}
                      className={`vsi-gw-opt ${
                        activePaymentTab === "square" ? "vsi-gw-sel" : ""
                      }`}
                    >
                      <span className="vsi-gw-logo vsi-gw-logo-sq">
                        <img
                          src={"/integrationimages/square-black.jpg"}
                          alt="Square"
                        />
                      </span>
                      Square
                      {squareSet && (
                        <span className="vsi-gw-configured">CONFIGURED</span>
                      )}
                    </button>
                    <button
                      onClick={() => {
                        setActivePaymentTab("payitforward");
                        setIsDirty(false);
                        setShowWebhookHelp(false);
                      }}
                      className={`vsi-gw-opt ${
                        activePaymentTab === "payitforward" ? "vsi-gw-sel" : ""
                      }`}
                    >
                      <span className="vsi-gw-logo vsi-gw-logo-pf">
                        <img src={"/images/Union-icon.png"} alt="Pay It Forward" />
                      </span>
                      Pay It Forward
                      {Boolean(show_pay_forward) && (
                        <span className="vsi-gw-configured">ON</span>
                      )}
                    </button>

                    {/* Contextual help */}
                    {activePaymentTab === "paypal" && (
                      <div className="vsi-gw-help">
                        Need help finding your keys?
                        <br />
                        <a
                          href={PaypalPdf}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Open the PayPal setup guide (PDF)
                        </a>
                      </div>
                    )}
                    {activePaymentTab === "stripe" && (
                      <div className="vsi-gw-help">
                        Need help finding your keys?
                        <br />
                        <a
                          href={StripePdf}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Open the Stripe setup guide (PDF)
                        </a>
                      </div>
                    )}
                    {activePaymentTab === "square" && (
                      <div className="vsi-gw-help">
                        Need help finding your keys?
                        <br />
                       <a
                          href={SquarePdf}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Open the Square setup guide (PDF)
                        </a>
                        <br />
                        <br />
                        Note: Square requires prices in the currency of the
                        country where your account was created. Ensure the
                        currency selected in our system matches it.
                      </div>
                    )}
                    {activePaymentTab === "payitforward" && (
                      <div className="vsi-gw-help">
                        Pay It Forward directs any contributions for your
                        sessions back to VerySoul. No API keys are needed.
                      </div>
                    )}
                  </div>

                  {/* Gateway forms */}
                  <div className="vsi-gw-form">
                    {activePaymentTab === "paypal" && (
                      <>
                        <div className="vsi-frow">
                          <div className="vsi-field">
                            <label>Client ID</label>
                            <div className="vsi-input">
                              <input
                                value={paypal_pub_key}
                                name="paypal_pub_key"
                                onChange={paymentChangeHandler}
                                type={typepaypal1 ? "password" : "text"}
                              />
                              <button
                                type="button"
                                className="vsi-eye"
                                onClick={() => changePassType(3)}
                                aria-label="Toggle visibility"
                              >
                                <EyeIcon open={!typepaypal1} />
                              </button>
                            </div>
                            {fieldErrors.paypal_pub_key && (
                              <span className="vsi-field-error">
                                Client ID is required
                              </span>
                            )}
                          </div>
                          <div className="vsi-field">
                            <label>Secret Code</label>
                            <div className="vsi-input">
                              <input
                                value={paypal_pri_key}
                                name="paypal_pri_key"
                                onChange={paymentChangeHandler}
                                type={typepaypal2 ? "password" : "text"}
                              />
                              <button
                                type="button"
                                className="vsi-eye"
                                onClick={() => changePassType(4)}
                                aria-label="Toggle visibility"
                              >
                                <EyeIcon open={!typepaypal2} />
                              </button>
                            </div>
                            {fieldErrors.paypal_pri_key && (
                              <span className="vsi-field-error">
                                Secret code is required
                              </span>
                            )}
                          </div>
                          <div className="vsi-field">
                            <label>PayPal Webhook ID</label>
                            <div className="vsi-input">
                              <input
                                value={paypal_webhook_id}
                                name="paypal_webhook_id"
                                onChange={paymentChangeHandler}
                                type={typepaypalwebhook ? "password" : "text"}
                              />
                              <button
                                type="button"
                                className="vsi-eye"
                                onClick={() => changePassType(8)}
                                aria-label="Toggle visibility"
                              >
                                <EyeIcon open={!typepaypalwebhook} />
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="vsi-field">
                          <label>VerySoul Webhook URL</label>
                          <div className="vsi-input">
                            <input value={getWebhookUrl("paypal")} readOnly />
                            <button
                              type="button"
                              className="vsi-eye"
                              onClick={() => copyWebhookUrl("paypal")}
                              aria-label="Copy webhook URL"
                              title="Copy"
                            >
                              <img
                                src="/images/copy.png"
                                alt="copy"
                                width="16"
                                height="16"
                              />
                            </button>
                          </div>
                        </div>
                        <div className="vsi-live-check">
                          <input
                            value={1}
                            onChange={changePayItforwardHandlerNew}
                            name="paypalcheckbox"
                            checked={paypalcheckbox == 1 ? "checked" : ""}
                            type="checkbox"
                            id="paypalcheckbox"
                          />
                          <label htmlFor="paypalcheckbox">
                            <b>My PayPal account is in Live mode</b>
                            <span>
                              I am sure that I have my payment account set in
                              Live mode, not Sandbox mode. Required before
                              saving.
                            </span>
                          </label>
                        </div>
                        {paypalcheckboxstatus && (
                          <span className="vsi-required">
                            Live mode confirmation is required
                          </span>
                        )}
                        {/* <div className="vsi-webhook-help">
                          <button
                            type="button"
                            className="vsi-webhook-help-toggle"
                            onClick={() => setShowWebhookHelp(!showWebhookHelp)}
                          >
                            <span>How to connect this webhook</span>
                            <span className="vsi-webhook-help-toggle-label">
                              {showWebhookHelp
                                ? "Close instructions"
                                : "Show instructions"}
                            </span>
                          </button>
                          {showWebhookHelp && (
                            <div className="vsi-webhook-help-body">
                              <a
                                className="vsi-webhook-help-link"
                                href={WEBHOOK_SETUP_GUIDE.paypal.dashboardUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {WEBHOOK_SETUP_GUIDE.paypal.dashboardLabel} ↗
                              </a>
                              <ul className="vsi-webhook-help-steps">
                                {WEBHOOK_SETUP_GUIDE.paypal.steps.map(
                                  (step, index) => (
                                    <li key={index}>
                                      <span className="vsi-webhook-help-step-num">
                                        {index + 1}
                                      </span>
                                      <span>{step}</span>
                                    </li>
                                  )
                                )}
                              </ul>
                            </div>
                          )}
                        </div> */}
                        <div className="vsi-form-foot">
                          <Button
                            className={
                              "resend-btn w-unset height-45 min-width-130px"
                            }
                            status={0}
                            onClick={() => savePaymentMethods("paypal")}
                            disabled={!isDirty}
                            title="Save"
                          />
                          <button
                            className="vsi-btn vsi-btn-ghost"
                            onClick={clearPaymentField}
                          >
                            Clear
                          </button>
                          <button
                            className="vsi-btn vsi-btn-ghost cancel_first_link_zoom"
                            onClick={() => setTabThree(false)}
                          >
                            Cancel
                          </button>
                        </div>
                      </>
                    )}

                    {activePaymentTab === "stripe" && (
                      <>
                        <div className="vsi-frow">
                          <div className="vsi-field">
                            <label>Publishable Key Token</label>
                            <div className="vsi-input">
                              <input
                                value={str_pub_key}
                                name="str_pub_key"
                                onChange={paymentChangeHandler}
                                type={typestripe1 ? "password" : "text"}
                              />
                              <button
                                type="button"
                                className="vsi-eye"
                                onClick={() => changePassType(1)}
                                aria-label="Toggle visibility"
                              >
                                <EyeIcon open={!typestripe1} />
                              </button>
                            </div>
                            {fieldErrors.str_pub_key && (
                              <span className="vsi-field-error">
                                Publishable key is required
                              </span>
                            )}
                          </div>
                          <div className="vsi-field">
                            <label>Secret Key</label>
                            <div className="vsi-input">
                              <input
                                value={str_pri_key}
                                name="str_pri_key"
                                onChange={paymentChangeHandler}
                                type={typestripe2 ? "password" : "text"}
                              />
                              <button
                                type="button"
                                className="vsi-eye"
                                onClick={() => changePassType(2)}
                                aria-label="Toggle visibility"
                              >
                                <EyeIcon open={!typestripe2} />
                              </button>
                            </div>
                            {fieldErrors.str_pri_key && (
                              <span className="vsi-field-error">
                                Secret key is required
                              </span>
                            )}
                          </div>
                          <div className="vsi-field">
                            <label>Stripe Webhook Signing Secret</label>
                            <div className="vsi-input">
                              <input
                                value={str_webhook_secret}
                                name="str_webhook_secret"
                                onChange={paymentChangeHandler}
                                type={typestripewebhook ? "password" : "text"}
                              />
                              <button
                                type="button"
                                className="vsi-eye"
                                onClick={() => changePassType(7)}
                                aria-label="Toggle visibility"
                              >
                                <EyeIcon open={!typestripewebhook} />
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="vsi-field">
                          <label>VerySoul Webhook URL</label>
                          <div className="vsi-input">
                            <input value={getWebhookUrl("stripe")} readOnly />
                            <button
                              type="button"
                              className="vsi-eye"
                              onClick={() => copyWebhookUrl("stripe")}
                              aria-label="Copy webhook URL"
                              title="Copy"
                            >
                              <img
                                src="/images/copy.png"
                                alt="copy"
                                width="16"
                                height="16"
                              />
                            </button>
                          </div>
                        </div>
                        <div className="vsi-live-check">
                          <input
                            value={1}
                            onChange={changePayItforwardHandlerNew}
                            name="stripecheckbox"
                            checked={stripecheckbox == 1 ? "checked" : ""}
                            type="checkbox"
                            id="stripecheckbox"
                          />
                          <label htmlFor="stripecheckbox">
                            <b>My Stripe account is in Live mode</b>
                            <span>
                              I am sure that I have my payment account set in
                              Live mode, not Sandbox mode. Required before
                              saving.
                            </span>
                          </label>
                        </div>
                        {stripecheckboxstatus && (
                          <span className="vsi-required">
                            Live mode confirmation is required
                          </span>
                        )}
                        {/* <div className="vsi-webhook-help">
                          <button
                            type="button"
                            className="vsi-webhook-help-toggle"
                            onClick={() => setShowWebhookHelp(!showWebhookHelp)}
                          >
                            <span>How to connect this webhook</span>
                            <span className="vsi-webhook-help-toggle-label">
                              {showWebhookHelp
                                ? "Close instructions"
                                : "Show instructions"}
                            </span>
                          </button>
                          {showWebhookHelp && (
                            <div className="vsi-webhook-help-body">
                              <a
                                className="vsi-webhook-help-link"
                                href={WEBHOOK_SETUP_GUIDE.stripe.dashboardUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {WEBHOOK_SETUP_GUIDE.stripe.dashboardLabel} ↗
                              </a>
                              <ul className="vsi-webhook-help-steps">
                                {WEBHOOK_SETUP_GUIDE.stripe.steps.map(
                                  (step, index) => (
                                    <li key={index}>
                                      <span className="vsi-webhook-help-step-num">
                                        {index + 1}
                                      </span>
                                      <span>{step}</span>
                                    </li>
                                  )
                                )}
                              </ul>
                            </div>
                          )}
                        </div> */}
                        <div className="vsi-form-foot">
                          <Button
                            className={
                              "resend-btn w-unset height-45 min-width-130px"
                            }
                            status={0}
                            onClick={() => savePaymentMethods("stripe")}
                            disabled={!isDirty}
                            title="Save"
                          />
                          <button
                            className="vsi-btn vsi-btn-ghost"
                            onClick={clearPaymentField}
                          >
                            Clear
                          </button>
                          <button
                            className="vsi-btn vsi-btn-ghost cancel_first_link_zoom"
                            onClick={() => setTabThree(false)}
                          >
                            Cancel
                          </button>
                        </div>
                      </>
                    )}

                    {activePaymentTab === "square" && (
                      <>
                        <div className="vsi-frow">
                          <div className="vsi-field">
                            <label>Production Access Token</label>
                            <div className="vsi-input">
                              <input
                                value={squareup_access_token}
                                name="squareup_access_token"
                                onChange={paymentChangeHandler}
                                type={typesquare1 ? "password" : "text"}
                              />
                              <button
                                type="button"
                                className="vsi-eye"
                                onClick={() => changePassType(5)}
                                aria-label="Toggle visibility"
                              >
                                <EyeIcon open={!typesquare1} />
                              </button>
                            </div>
                            {fieldErrors.squareup_access_token && (
                              <span className="vsi-field-error">
                                Access token is required
                              </span>
                            )}
                          </div>
                          <div className="vsi-field">
                            <label>Location ID</label>
                            <div className="vsi-input">
                              <input
                                value={square_location_id}
                                name="square_location_id"
                                onChange={paymentChangeHandler}
                                type={typesquare2 ? "password" : "text"}
                              />
                              <button
                                type="button"
                                className="vsi-eye"
                                onClick={() => changePassType(6)}
                                aria-label="Toggle visibility"
                              >
                                <EyeIcon open={!typesquare2} />
                              </button>
                            </div>
                            {fieldErrors.square_location_id && (
                              <span className="vsi-field-error">
                                Location ID is required
                              </span>
                            )}
                          </div>
                          <div className="vsi-field">
                            <label>Square Webhook Signature Key</label>
                            <div className="vsi-input">
                              <input
                                value={square_webhook_signature_key}
                                name="square_webhook_signature_key"
                                onChange={paymentChangeHandler}
                                type={typesquarewebhook ? "password" : "text"}
                              />
                              <button
                                type="button"
                                className="vsi-eye"
                                onClick={() => changePassType(9)}
                                aria-label="Toggle visibility"
                              >
                                <EyeIcon open={!typesquarewebhook} />
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="vsi-field">
                          <label>VerySoul Webhook URL</label>
                          <div className="vsi-input">
                            <input value={getWebhookUrl("square")} readOnly />
                            <button
                              type="button"
                              className="vsi-eye"
                              onClick={() => copyWebhookUrl("square")}
                              aria-label="Copy webhook URL"
                              title="Copy"
                            >
                              <img
                                src="/images/copy.png"
                                alt="copy"
                                width="16"
                                height="16"
                              />
                            </button>
                          </div>
                        </div>
                        <div className="vsi-live-check">
                          <input
                            value={1}
                            onChange={changePayItforwardHandlerNew}
                            name="squarecheckbox"
                            checked={squarecheckbox == 1 ? "checked" : ""}
                            type="checkbox"
                            id="squarecheckbox"
                          />
                          <label htmlFor="squarecheckbox">
                            <b>My Square account is in Live mode</b>
                            <span>
                              I am sure that I have my payment account set in
                              Live mode, not Sandbox mode. Required before
                              saving.
                            </span>
                          </label>
                        </div>
                        {squarecheckboxstatus && (
                          <span className="vsi-required">
                            Live mode confirmation is required
                          </span>
                        )}
                        {/* <div className="vsi-webhook-help">
                          <button
                            type="button"
                            className="vsi-webhook-help-toggle"
                            onClick={() => setShowWebhookHelp(!showWebhookHelp)}
                          >
                            <span>How to connect this webhook</span>
                            <span className="vsi-webhook-help-toggle-label">
                              {showWebhookHelp
                                ? "Close instructions"
                                : "Show instructions"}
                            </span>
                          </button>
                          {showWebhookHelp && (
                            <div className="vsi-webhook-help-body">
                              <a
                                className="vsi-webhook-help-link"
                                href={WEBHOOK_SETUP_GUIDE.square.dashboardUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {WEBHOOK_SETUP_GUIDE.square.dashboardLabel} ↗
                              </a>
                              <ul className="vsi-webhook-help-steps">
                                {WEBHOOK_SETUP_GUIDE.square.steps.map(
                                  (step, index) => (
                                    <li key={index}>
                                      <span className="vsi-webhook-help-step-num">
                                        {index + 1}
                                      </span>
                                      <span>{step}</span>
                                    </li>
                                  )
                                )}
                              </ul>
                            </div>
                          )}
                        </div> */}
                        <div className="vsi-form-foot">
                          <Button
                            className={
                              "resend-btn w-unset height-45 min-width-130px"
                            }
                            status={0}
                            onClick={() => savePaymentMethods("square")}
                            disabled={!isDirty}
                            title="Save"
                          />
                          <button
                            className="vsi-btn vsi-btn-ghost"
                            onClick={clearPaymentField}
                          >
                            Clear
                          </button>
                          <button
                            className="vsi-btn vsi-btn-ghost cancel_first_link_zoom"
                            onClick={() => setTabThree(false)}
                          >
                            Cancel
                          </button>
                        </div>
                      </>
                    )}

                    {activePaymentTab === "payitforward" && (
                      <>
                        <div className="vsi-pif-check">
                          <input
                            value={1}
                            onChange={changePayItforwardHandler}
                            name="suggestedprice"
                            checked={pay_forward == 1 ? "checked" : ""}
                            type="checkbox"
                            id="suggestedprice"
                          />
                          <label htmlFor="suggestedprice">
                            I would like any contributions for my sessions to be
                            directed back to VerySoul, to help Pay it Forward,
                            and I understand that these amounts are not
                            recoverable by me.
                          </label>
                        </div>
                        <div className="vsi-form-foot">
                          <button
                            className="vsi-btn vsi-btn-primary resend-btn cancel_first_link_zoom"
                            onClick={() =>
                              savePaymentToForwardHandler("payitforward")
                            }
                          >
                            Save
                          </button>
                          <button
                            className="vsi-btn vsi-btn-ghost cancel_first_link_zoom"
                            onClick={() => setTabThree(false)}
                          >
                            Close
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              )}
            </div>
          )}
          </div>
        </div>
      </div>

      {/* ---------- Modals (unchanged behavior) ---------- */}
      <ConfirmDeleteModal
        deleteUser={unlinkHnalder}
        id={"ConfirmDeleteModalZoom"}
        label={"Sure you want to unlink ?"}
        btnLabel={"Continue"}
      />
      <ConfirmDeleteModal
        deleteUser={unlinkHnalder}
        id={"ConfirmDeleteModalCalendar"}
        label={"Sure you want to unlink ?"}
        btnLabel={"Continue"}
      />

      <div className="">
        <div className="modal fade" id="integration-modal" role="dialog">
          <div className="modal-dialog modal-dialog-preview">
            <div className="modal-content">
              <div className="modal-body text-align-unset">
                <h4 className="text-center mt-2">Choose your calendar</h4>
                {calendarList.map((item) => (
                  <div
                    onClick={() => selectCalendarHandler(item)}
                    className={`calendar-card pointer ${
                      item.status ? "calendar-card-norder" : ""
                    }`}
                  >
                    <p className="letter-spacing-1px">
                      <b>Calendar Name </b>: {item.summary}
                    </p>
                    <p className="letter-spacing-1px">
                      <b>Time Zone</b> : {item.timeZone}
                    </p>
                  </div>
                ))}
                <div className="text-center">
                  <Button
                    className={"resend-btn w-unset height-45 min-width-130px"}
                    status={0}
                    onClick={saveSelectedCalendar}
                    title="Save Calendar"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*******************/}

        <GoToAvailability />
      </div>
      <ConfirmIfCalendarSelected
        confirmCalendarSetup={confirmCalendarSetup}
        setconfirmCalendarSetup={setconfirmCalendarSetup}
        finishPopupHandler={finishPopupHandler}
      />
      {/* <FinishPopup
        finishPopupHandler={finishPopupHandler}
        cancelFinishPopupHandler={cancelFinishPopupHandler}
      /> */}
    </>
  );
}
